import { create } from "zustand";
import { ProofPayload } from "../types";

interface ProofStore {
  proof?: ProofPayload;
  setProof: (proof: ProofPayload) => void;
}

export const useProofStore = create<ProofStore>((set) => ({
  proof: undefined,
  setProof: (proof: ProofPayload) => set({ proof }),
}));
